import { createContext, useContext, useEffect, useState, type ReactNode } from 'react';

/**
 * CİHAZ AYRIMI — devir dokümanı §6.11.
 *
 * *"v9 kararı: şantiye şefinin mobil ve masaüstü ekranları TAMAMEN AYRI.
 *   Mobil ≠ masaüstünün küçüğü."*
 *
 * ⚠️ BU BİR ROL KURALI DEĞİLDİR. Daha önce rol ile cihaz karıştırılmıştı:
 *    ekran seçimi `sefYetkisi`ye bakıyordu, dolayısıyla şef telefondan girince
 *    panoyu küçültülmüş halde görüyordu — §6.11'in tam olarak reddettiği şey.
 *    Aynı hata ters yönde de vardı: masaüstünde saha kullanıcısına kabuk hiç
 *    verilmiyordu.
 *
 * Eşik Tailwind `lg` ile aynı (1024px) — CSS ve JS'in aynı yerde bölünmesi şart,
 * yoksa kabuk mobil moda geçerken içerik masaüstü düzeninde kalır.
 */

const TELEFON_SORGU = '(max-width: 1023px)';

const CihazCtx = createContext<boolean>(false);

/**
 * Telefon görünümünde miyiz?
 *
 * Gerçek ekran genişliği VEYA temsil simülasyonu (masaüstünde telefon çerçevesi)
 * bunu true yapar — çağıran taraf ikisini ayırt etmek zorunda kalmasın.
 */
export function useTelefon(): boolean {
  return useContext(CihazCtx);
}

/** Simülasyondan bağımsız, GERÇEK ekran genişliği. Çerçeveyi çizecek olan bunu sorar. */
export function useGercekTelefon(): boolean {
  const [telefon, setTelefon] = useState(() => window.matchMedia(TELEFON_SORGU).matches);

  useEffect(() => {
    const mq = window.matchMedia(TELEFON_SORGU);
    const dinle = (e: MediaQueryListEvent) => setTelefon(e.matches);
    mq.addEventListener('change', dinle);
    // Dinleyici bağlanana kadar genişlik değişmiş olabilir (döndürme, çekmece).
    setTelefon(mq.matches);
    return () => mq.removeEventListener('change', dinle);
  }, []);

  return telefon;
}

export function CihazSaglayici({ telefon, children }: { telefon: boolean; children: ReactNode }) {
  return <CihazCtx.Provider value={telefon}>{children}</CihazCtx.Provider>;
}
